<div class="token-container">
  <p-card header="Access Token" styleClass="token-card">
    <div class="token-content">
      <div class="token-display">
        <input 
          pInputText 
          [value]="accessToken" 
          readonly 
          class="token-input"
          type="text"
        />
      </div>
      
      <div class="copy-button-container">
        <p-button 
          label="Copy" 
          icon="pi pi-copy" 
          severity="secondary"
          (onClick)="copyToken()"
          styleClass="copy-button"
        ></p-button>
      </div>
    </div>
  </p-card>
</div>